import { useEffect, useMemo, useState } from 'react';
import {
  defaultFilters,
  FiltersParamsType,
} from 'domains/Orders/Orders/ordersService';
import { SavedSearchInterface } from 'domains/Orders/Orders/ordersSlice/savedSearches';
import { areFiltersEquals } from 'domains/Orders/Orders/utils/OrderListFilter/utils';
import { useSavedSearches } from './useSavedSearches';

export function useSelectedSavedSearch(filters: FiltersParamsType) {
  const [selectedSavedSearch, setSelectedSavedSearch] =
    useState<SavedSearchInterface | null>(null);
  const { savedSearches } = useSavedSearches();

  const filtersMatchSavedSearch = (
    filters: FiltersParamsType,
    ss: SavedSearchInterface,
  ) => {
    const transformedFilters = {
      ...defaultFilters,
      ...ss.filters,
    };
    return areFiltersEquals(filters, transformedFilters);
  };

  const filtersMatchWithSavedSearch = useMemo(() => {
    // If the selected saved search already matches the filters we do nothing
    // since otherwise we override saved search selection if they share the same defined
    // filters
    if (
      selectedSavedSearch &&
      filtersMatchSavedSearch(filters, selectedSavedSearch)
    ) {
      return [selectedSavedSearch];
    }
    return savedSearches.filter((ss) => filtersMatchSavedSearch(filters, ss));
  }, [filters, savedSearches, selectedSavedSearch]);

  useEffect(() => {
    setSelectedSavedSearch(
      filtersMatchWithSavedSearch.length > 0
        ? filtersMatchWithSavedSearch[0]
        : null,
    );
  }, [filtersMatchWithSavedSearch, selectedSavedSearch]);

  return {
    selectedSavedSearch,
    setSelectedSavedSearch,
  };
}
